module.exports = __webpack_public_path__ + "img/2Dline_example.44a7c216.png";